import { PropsWithChildren } from "react";
import FacetedFilterCategory, {
  type FacetedFilterCategoryProps,
} from "@/pages/(app)/returns/list/components/faceted-filter/faceted-filter-category";
import FacetedFilterType, {
  type FacetedFilterTypeProps,
} from "@/pages/(app)/returns/list/components/faceted-filter/faceted-filter-type";
import FacetedFilterValue, {
  type FacetedFilterValueProps,
} from "@/pages/(app)/returns/list/components/faceted-filter/faceted-filter-value";
import { Separator } from "@babackapp/ui/components/separator";
import { X } from "lucide-react";

interface FacetedFilterProps extends PropsWithChildren {
  categoryProps: FacetedFilterCategoryProps;
  typeProps: FacetedFilterTypeProps;
  valueProps: FacetedFilterValueProps;
  onClearClick: () => void;
}

export default function FacetedFilter(props: FacetedFilterProps) {
  const { categoryProps, typeProps, valueProps, onClearClick } = props;

  return (
    <div
      className={
        "border flex flex-row items-center rounded-md overflow-hidden h-8"
      }
    >
      <FacetedFilterCategory {...categoryProps} />
      <Separator orientation={"vertical"} />
      <FacetedFilterType {...typeProps} />
      <Separator orientation={"vertical"} />
      <FacetedFilterValue {...valueProps} />
      <Separator orientation={"vertical"} />
      <div
        className={
          "flex h-full items-center hover:bg-accent hover:text-accent-foreground px-2 justify-center cursor-pointer"
        }
        onClick={onClearClick}
      >
        <X className={"h-4 w-4"} />
      </div>
    </div>
  );
}
